<template>
  <div id="app">
    <site-banner></site-banner>
    <top-bar></top-bar>
    <div>
      <div class="main-page">
        <div class="columns">
          <div class="column is-one-fifth">
            <links-menu></links-menu>
          </div>
          <div class="column">
            <div class="is-main-content">
              <router-view/>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
    <!--<div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->

    <site-footer />
  </div>
</template>

<style>
#app {
  margin:0;
  background-color: #a53a28;
  font-family: Calibri, sans-serif;
  color: #0f0f0f;
  font-size: 100%;
}
html{
  background-color: #a53a28 !important;
}

.main-page{
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  background: #ebebeb;
  position: relative;
}

.is-main-content{
  padding-right: 40px;
}

.is-main-content p{
  font-size: 14px;
  text-align: justify;
  margin: 1em;
  line-height: 1.4;
}
</style>
<script>
import SiteBanner from "./components/fixed/SiteBanner";
import SiteFooter from "./components/fixed/SiteFooter";
import TopBar from "./components/fixed/TopBar";
import LinksMenu from "./components/fixed/LinksMenu";
export default {
  metaInfo: {
    title: 'CEHR - Sub Beati Petri',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
  components: {LinksMenu, TopBar, SiteFooter, SiteBanner}
}
</script>